(function () {
  angular.module("akitabox.ui.dialogs.workOrder.reopen", [
    "akitabox.core.constants",
    "akitabox.core.services.workOrder",
    "akitabox.core.toast",
  ]);
})();
